var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5312 0.125H5.46875C2.44844 0.125 0 2.57344 0 5.59375V29.6562C0 32.6766 2.44844 35.125 5.46875 35.125H29.5312C32.5516 35.125 35 32.6766 35 29.6562V5.59375C35 2.57344 32.5516 0.125 29.5312 0.125Z",
    fill: "#2867B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 26.375H8.96875V14.6719H12.6875V26.375ZM10.8281 13.0313C9.625 13.0313 8.75 12.1562 8.75 10.9531C8.75 9.75 9.73438 8.875 10.8281 8.875C12.0313 8.875 12.9063 9.75 12.9063 10.9531C12.9063 12.1562 12.0313 13.0313 10.8281 13.0313ZM26.25 26.375H22.5313V20.0313C22.5313 18.1719 21.7656 17.625 20.6719 17.625C19.5781 17.625 18.4844 18.5 18.4844 20.1406V26.375H14.7656V14.6719H18.2656V16.3125C18.5937 15.5469 19.9062 14.3438 21.7656 14.3438C23.8437 14.3438 26.0313 15.5469 26.0313 19.1562V26.375H26.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinicon);
export default __webpack_public_path__ + "static/media/linkedinicon.7fdc5e87b8cf47b8e12b4f600d212827.svg";
export { ForwardRef as ReactComponent };